export const useIsBusinessReport = () => {
  const { localeProperties } = useI18n()

  return computed(() => Boolean(localeProperties.value?.isBusinessReport))
}
